
import { Card, CardContent } from "@/components/ui/card";
import { Users, Calendar, Heart, Award, ChartBar } from "lucide-react";

export const StatisticsSection = () => {
  const stats = [
    {
      icon: Users,
      value: "10,000+",
      label: "Utilisateurs actifs",
      description: "Utilisateurs qui utilisent activement notre plateforme"
    },
    {
      icon: Calendar,
      value: "50,000+",
      label: "Rendez-vous",
      description: "Rendez-vous médicaux planifiés via notre plateforme"
    },
    {
      icon: Heart,
      value: "95%",
      label: "Satisfaction",
      description: "Taux de satisfaction de nos utilisateurs"
    },
    {
      icon: Award,
      value: "24/7",
      label: "Support",
      description: "Assistance disponible à tout moment"
    }
  ];

  return (
    <div className="py-4 md:py-16 px-2 md:px-8">
      <div className="text-center mb-4 md:mb-12">
        <div className="flex items-center justify-center gap-2 mb-2 md:mb-4">
          <ChartBar className="h-4 w-4 md:h-6 md:w-6 text-primary md:hidden" />
          <h2 className="text-xl md:text-3xl font-bold">Nos statistiques</h2>
        </div>
        <p className="text-lg text-muted-foreground hidden md:block">
          Des chiffres qui parlent d'eux-mêmes
        </p>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-8">
        {stats.map((stat, index) => (
          <Card key={index} className="text-center">
            <CardContent className="pt-3 md:pt-6">
              <div className="mx-auto w-8 h-8 md:w-12 md:h-12 rounded-full bg-primary/10 flex items-center justify-center mb-2 md:mb-4">
                <stat.icon className="w-4 h-4 md:w-6 md:h-6 text-primary" />
              </div>
              <div className="space-y-1 md:space-y-2">
                <p className="text-lg md:text-3xl font-bold text-primary">{stat.value}</p>
                <p className="font-medium text-xs md:text-base">{stat.label}</p>
                <p className="text-xs md:text-sm text-muted-foreground hidden md:block">{stat.description}</p>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};
